var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card_collecting"},[_c('div',{staticClass:"qs_img"},[_c('img',{attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coll_qs.png","alt":""}})]),_c('div',{staticClass:"qs_title"},[_vm._v("活动即将开启，敬请期待~")])])
}]

export { render, staticRenderFns }